import React from "react";
import { Order } from "../../../lib/model/Order";
import { Row, Col, Divider } from "antd";
import styled from "styled-components";
import { priceString } from "../../../lib/formatters";
import {
  OrderStatus,
  hasStatusReachedStatus
} from "../../../lib/model/OrderStatus";

const DescriptionLabel = styled.span`
  font-size: 11px;
  font-weight: 300;
  line-height: 1.82;
  color: #c3c3bf;
  display: inline-box;
`;

const ValueLabel = styled.span`
  font-size: 14px;
  font-weight: 300;
  line-height: 1.21;
  color: #1d1d1b;
  display: inline-box;
`;

const BoldValueLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.21;
  color: #1d1d1b;
  display: inline-box;
`;

const TotalLabel = styled.span`
  font-size: 28px;
  font-weight: 400;
  line-height: 1.29;
  color: #386ee8;
  display: inline-box;
`;

type Props = {
  order: Order;
};

export class OrderPriceList extends React.Component<Props> {
  render() {
    const { order } = this.props;
    return (
      <>
        <Row type="flex" align="bottom" style={{ textAlign: "right" }}>
          <Col span={14}>
            <DescriptionLabel>Grundpreis</DescriptionLabel>
          </Col>
          <Col span={10}>
            <BoldValueLabel>
              {priceString(
                order.basePrice.net +
                  order.extras.reduce((acc, e) => acc + e.value.net, 0)
              )}
            </BoldValueLabel>
          </Col>
        </Row>
        {order.waitingTimeExtra && (
          <>
            <Row type="flex" align="bottom">
              <Col span={24}>
                <Divider style={{ margin: "8px 0" }} />
              </Col>
            </Row>
            <Row type="flex" align="bottom" style={{ textAlign: "right" }}>
              <Col span={14}>
                <DescriptionLabel>Inkludierte Wartezeit</DescriptionLabel>
              </Col>
              <Col span={10}>
                <ValueLabel>
                  {Object.values(order.waitingTimeExtra.tours).reduce(
                    (acc, w) => acc + w.allowedFreeMins,
                    0
                  )}{" "}
                  min
                </ValueLabel>
              </Col>
            </Row>
            <Row type="flex" align="bottom" style={{ textAlign: "right" }}>
              <Col span={14}>
                <DescriptionLabel>Genutzte Wartezeit</DescriptionLabel>
              </Col>
              <Col span={10}>
                <ValueLabel>
                  {Object.values(order.waitingTimeExtra.tours).reduce(
                    (acc, w) => acc + w.usedMins,
                    0
                  )}{" "}
                  min
                </ValueLabel>
              </Col>
            </Row>
            <Row type="flex" align="bottom" style={{ textAlign: "right" }}>
              <Col span={14}>
                <DescriptionLabel>gebührenpflichtige Wartezeit</DescriptionLabel>
              </Col>
              <Col span={10}>
                <ValueLabel>
                  +{" "}
                  {Object.values(order.waitingTimeExtra.tours).reduce(
                    (acc, w) => acc + w.billedMins,
                    0
                  )}{" "}
                  min
                </ValueLabel>
              </Col>
            </Row>
            <Row type="flex" align="bottom" style={{ textAlign: "right" }}>
              <Col span={14}>
                <DescriptionLabel>Kosten für Wartezeit</DescriptionLabel>
              </Col>
              <Col span={10}>
                <BoldValueLabel>
                  +{" "}
                  {priceString(
                    Object.values(order.waitingTimeExtra.tours).reduce(
                      (acc, w) => acc + w.value.net,
                      0
                    )
                  )}
                </BoldValueLabel>
              </Col>
            </Row>
          </>
        )}
        <Row type="flex" align="bottom">
          <Col span={24}>
            <Divider style={{ margin: "8px 0" }} />
          </Col>
        </Row>
        <Row type="flex" align="bottom" style={{ textAlign: "right" }}>
          <Col span={14}>
            <DescriptionLabel>
              {hasStatusReachedStatus(order.status, OrderStatus.ReadyToInvoice)
                ? "Gesamtpreis"
                : "Grundpreis"}
            </DescriptionLabel>
          </Col>
          <Col span={10}>
            <TotalLabel>{priceString(order.fullPrice.net)}</TotalLabel>
          </Col>
        </Row>
      </>
    );
  }
}
